import { ReactComponent as GreyCheck } from "../../assets/images/grey-check.svg";
import styles from "./option-detail.module.css";

export default function OptionDetail({
    text,
    sup,
}: {
    text: string;
    sup?: string;
}): JSX.Element {
    return (
        <div className={styles["option-detail"]}>
            <GreyCheck className={styles["option-detail__icon"]} />
            <span className={styles["option-detail__text"]}>
                {text}
                {sup && <sup>{sup}</sup>}
            </span>
        </div>
    );
}
